import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export type ConnectionStatusType = 'connected' | 'disconnected' | 'reconnecting' | 'error'

export const useConnectionStore = defineStore('connection', () => {
  const status = ref<ConnectionStatusType>('disconnected')
  const usagePercent = ref<number>(0)

  const connectionClass = computed(() => {
    if (status.value === 'connected') return 'connected'
    if (status.value === 'reconnecting') return 'reconnecting'
    return 'disconnected'
  })

  const connectionTooltip = computed(() => {
    switch (status.value) {
      case 'connected':
        return 'Bağlantı aktif'
      case 'disconnected':
        return 'Bağlantı kesildi'
      case 'reconnecting':
        return 'Yeniden bağlanılıyor...'
      case 'error':
        return 'Bağlantı hatası'
      default:
        return 'Bağlantı kesildi'
    }
  })

  function setStatus(newStatus: ConnectionStatusType) {
    status.value = newStatus
  }

  function setUsagePercent(percent: number) {
    usagePercent.value = percent
  }

  return {
    status,
    usagePercent,
    connectionClass,
    connectionTooltip,
    setStatus,
    setUsagePercent
  }
})
